import { render } from "./ModalPublishing.vue?vue&type=template&id=02974673&scoped=true"
import script from "./ModalPublishing.vue?vue&type=script&lang=js"
export * from "./ModalPublishing.vue?vue&type=script&lang=js"

import "./ModalPublishing.vue?vue&type=style&index=0&id=02974673&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02974673"]])

export default __exports__